import core from '@/assets/intelligence-core.png';

const scienceWords = [
  'SCOPUS',
  'WEB OF SCIENCE',
  'DOI · CROSSREF',
  'ORCID',
  'RESEARCH AI',
  'OPENALEX',
];

interface IntelligenceCoreProps {
  size?: 'default' | 'small';
  caption?: { title: string; subtitle: string };
  showWords?: boolean;
}

export const IntelligenceCore = ({
  size = 'default',
  caption,
  showWords = false,
}: IntelligenceCoreProps) => (
  <div className={size === 'small' ? 'hero-center hero-center--sm' : 'hero-center'}>
    <div className={size === 'small' ? 'ai-core-wrap ai-core-wrap--sm' : 'ai-core-wrap'}>
      <div className="core-aura" />
      <img className="ai-core" src={core} alt="" aria-hidden="true" loading="lazy" />
      <div className="orbit-ring r1" />
      <div className="orbit-ring r2" />
      <div className="orbit-ring r3" />
      {showWords &&
        scienceWords.map((word, index) => (
          <span key={word} className={`science-word w${index + 1}`}>
            {word}
          </span>
        ))}
      {caption && (
        <div className="core-caption">
          <strong>{caption.title}</strong>
          {caption.subtitle}
        </div>
      )}
    </div>
  </div>
);
